import { render, staticRenderFns } from "./TermsArrayEditor.vue?vue&type=template&id=0765d41a&scoped=true&"
import script from "./TermsArrayEditor.vue?vue&type=script&lang=js&"
export * from "./TermsArrayEditor.vue?vue&type=script&lang=js&"
import style0 from "./TermsArrayEditor.vue?vue&type=style&index=0&id=0765d41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765d41a",
  null
  
)

export default component.exports